import React from 'react'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

import LocationSelectorContainer from '../../containers/forms/location-selector-container'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

export default ({
  fields: {
    locationId,
    contact
  },

  locations,

  submitButtonText,

  handleClose,
  modalTitle,
  handleSubmit,

  loading
}) => {
  if (loading) return <p>Loading...</p>

  return (
    <BaseModal
      onClose={handleClose}
      title={modalTitle}
      constraints={constraints}
      contentClassName='work-orders-create-container'
    >
      <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='location'>location</label>

            <LocationSelectorContainer {...locationId} />
          </ModalFormBlock>
        </ModalFormRow>
        <ModalFormRow>
          <ModalFormBlock>
            <label htmlFor='contact'>contact</label>
            <input id='contact' type='text' placeholder='Type name' {...contact} />
          </ModalFormBlock>
        </ModalFormRow>
        <ModalFormRow>
          <ModalFormBlock submitButton>
            <button type='submit'>{submitButtonText || 'Submit'}</button>
          </ModalFormBlock>
        </ModalFormRow>
      </ModalForm>
    </BaseModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/qa-work-orders/qa-work-order-form.js